<template>
  <DialogTemplate :is-open="isOpen" class="DialogTemplateArea" @click-mask="onClickMask">
    <div class="alertContent" :class="{ isPc: !isSp }">
      <div class="text" :class="{ isPc: !isSp }" v-text="text" />
      <div v-if="subText !== undefined" class="subText" :class="{ isPc: !isSp }" v-text="subText" />
      <ButtonTypeCustom
        class="button"
        :class="{ isPc: !isSp }"
        button-type="button"
        :button-text="buttonCustomText"
        button-color="colorPrimary"
        button-size="sizeLarge"
        @button-clicked="onClickOK"
      />
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from './DialogTemplate.vue';
import ButtonTypeCustom from '../Button/ButtonTypeCustom.vue';

export default {
  name: 'Alert',
  components: {
    DialogTemplate,
    ButtonTypeCustom,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    /**
     * テキスト。
     * 改行文字改行しますが、『text="sample"』形式だと改行文字効かないので、『:text="'sample'"』で送ってください
     */
    text: {
      type: String,
      required: true,
    },
    subText: {
      type: String,
      required: false,
      default: undefined,
    },
    /**
     * OKカスタムテキスト
     * 入力なければOKのまま
     */
    buttonCustomText: {
      type: String,
      required: false,
      default: 'OK',
    },
    /**
     * 永続オプション
     * trueの場合はMaskクリックで消えない
     * falseの場合はMaskクリックで消える、返却はfalse
     * マスクを誤タップして消えるのを防ぐため、デフォルトtrue
     */
    persistent: {
      type: Boolean,
      required: false,
      default: true,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
  methods: {
    onClickMask() {
      if (!this.persistent) {
        this.$emit('close-dialog', false);
      }
    },
    onClickOK() {
      this.$emit('close-dialog', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

@mixin text() {
  white-space: pre-wrap;
  text-align: center;
  line-height: $text-line-height-default;
}

.alertContent {
  &.isPc {
    width: 320px;
  }

  .text {
    @include text;

    margin-top: 12px;
    font-size: $text-size-paragraph1;
    font-weight: $text-weight-bold;

    &.isPc {
      margin-top: 20px;
    }
  }

  .subText {
    @include text;

    font-size: $text-size-paragraph2;
    margin-top: 16px;

    &.isPc {
      margin-top: 24px;
    }
  }

  .button {
    margin-top: 32px;

    &.isPc {
      margin-bottom: 20px;
    }
  }
}
</style>
